export default "__VITE_ASSET__bd$C18GU__"